import Form from "../components/Form";
function Forms(props) {
  return <Form></Form>;
}

export default Forms;
